import styled from 'styled-components';
import { key } from 'styled-theme';

import { media } from '../../../../utils/styles';
import { GlobalThemeProps } from '../../../../themes/types';

const padding = {
  md: 20,
  lg: 40,
};

export default styled.div`
  display: block;
  position: relative;
  box-shadow: ${key('outlines.shadow.default')};
  background: ${key('colors.white')};
  position: relative;
  padding: 20px;
  border-bottom-right-radius: ${key('sizes.borderRadius')};
  border-bottom-left-radius: ${key('sizes.borderRadius')};

  ${media.moreThan('md')`
    padding: ${(props: GlobalThemeProps) =>
      padding.md - props.theme.sizes.shadowSpace.large}px
      ${padding.md}px ${padding.md}px ${padding.md}px;
  `};

  ${media.moreThan('lg')`
    padding: ${(props: GlobalThemeProps) =>
      padding.lg - props.theme.sizes.shadowSpace.large}px
      ${padding.lg}px ${padding.lg}px ${padding.lg}px;
  `};
`;
